import { FormItem } from '@/components';
import { COLORS } from '@/theme';
import { Select } from '@/ui';
import styled from 'styled-components';

export const StyledFiltersWrapper = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  gap: 1rem;
`;

export const StyledFormItem = styled(FormItem)`
  &&& .ant-form-item-label label {
    color: ${COLORS.IRON_GRAY};
  }
`;

export const StyledSelect = styled(Select)`
  text-align: left;

  &&& {
    min-height: 2.875rem;
    height: auto;
    max-width: 100%;
    width: 100%;

    .ant-select-selection-placeholder {
      color: ${COLORS.GRAY_PRIMARY};
    }

    .ant-select-selector {
      min-height: 2.875rem;
      overflow: hidden;
      padding-top: 0.15rem;
      max-width: 100%;
    }

    .ant-select-selection-wrap {
      align-self: center;
    }

    .ant-select-selection-overflow {
      flex-wrap: nowrap !important;
      overflow: hidden;
      white-space: nowrap;
      max-width: 100%;

      & .ant-select-selection-overflow-item span {
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        max-width: 8vw;
        line-height: 2rem;
      }

      & .ant-select-selection-overflow-item-rest div {
        border: none;
        color: ${COLORS.GRAY_PRIMARY};
      }

      & .ant-select-selection-overflow-item-suffix {
        padding-left: 0.25rem;
      }
    }

    .ant-select-clear {
      inset-inline-end: 0.25rem;
      top: 50%;
      width: fit-content;
      height: fit-content;
    }
  }
`;
